import { gql } from '@apollo/client';

export const SUBMIT_PARTNER_PENALTY_UPLOAD = gql`
  mutation SubmitPartnerPenaltyUpload($fileBase64: String!, $fileName: String!) {
    submitPartnerPenaltyUpload(fileBase64: $fileBase64, fileName: $fileName)
  }
`;
